import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from "react-router-dom";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import FAQ from "components/faqs/SingleColVendorList.js";
import { requestServer } from '../services/request.js';
import { ReactComponent as Forklift } from "../images/forklift.svg";
import operations from "../images/operations.jpg";
const Container = tw.div`mb-12 relative`;

function ListVendors() {
    const location = useLocation();
    const history = useHistory();

    const [vendors, setVendors] = useState()

    const listVendors = (load) => {

        requestServer(load).then((res) => {
            // setProcess(true)
            console.log(res.data.data);
            setVendors(res.data.data);
        }).catch((err) => {
            // setProcess(true)
            history.push('/')
            console.log(err)
        })
    }

    useEffect(() => {
        window.scrollTo(0, 0)
        if (location.state)
            listVendors(location.state);
        else
            history.push('/')
    }, [location, history]);

    return (
        <AnimationRevealPage disabled>
            <Header />
            {/* <TeamCardGrid 
                subheading={<Subheading>Our Team</Subheading>}
            /> */}
            <Container>
                {vendors ? <> <FAQ
                    // imageSrc={customerSupportIllustrationSrc}
                    imageContain={false}
                    imageShadow={true}
                    imageSrc="https://www.devsnews.com/template/logio/logio/assets/img/bg/bg-03.jpg"
                    subheading="Vendors"
                    heading={
                        <>
                            Choose your desired rates for <span tw="text-orange-500">{location?.state.data.countryname} ?</span>
                        </>
                    }
                    dataload={location.state}
                    faqs={[
                        {
                            vendor: "FedEx",
                            gstrate: vendors?.fedexPricing[0]?.gstrate,
                            gst: vendors?.fedexPricing[0]?.gst,
                            fuelsurgetaxrate: vendors?.fedexPricing[0]?.fuelsurgetaxrate,
                            fuelsurgetax: vendors?.fedexPricing[0]?.fuelsurgetax,
                            baseprice: vendors?.fedexPricing[0]?.finalPrice,
                            totalprice: vendors?.fedexPricing[0]?.totalprice,
                        },
                        {
                            vendor: "DHL",
                            gstrate: vendors?.dhlPricing[0]?.gstrate,
                            gst: vendors?.dhlPricing[0]?.gst,
                            fuelsurgetaxrate: vendors?.dhlPricing[0]?.fuelsurgetaxrate,
                            fuelsurgetax: vendors?.dhlPricing[0]?.fuelsurgetax,
                            baseprice: vendors?.dhlPricing[0]?.finalPrice,
                            totalprice: vendors?.dhlPricing[0]?.totalprice,
                        },
                        {
                            vendor: "UPS",
                            gstrate: vendors?.upsPricing[0]?.gstrate,
                            gst: vendors?.upsPricing[0]?.gst,
                            fuelsurgetaxrate: vendors?.upsPricing[0]?.fuelsurgetaxrate,
                            fuelsurgetax: vendors?.upsPricing[0]?.fuelsurgetax,
                            baseprice: vendors?.upsPricing[0]?.finalPrice,
                            totalprice: vendors?.upsPricing[0]?.totalprice,
                        }
                    ]}
                /> <img src={operations} alt="" />
                </>
                    :
                    <div style={{ height: 200 }} tw="py-5 mb-20">
                        <Forklift tw="mx-auto h-full w-full animate-pulse" />
                        <h1 tw="font-bold text-center text-xl mt-6">Loading</h1>
                    </div>}
            </Container>
            <Footer />
        </AnimationRevealPage>
    )
}

export default ListVendors
